import React from 'react'

export default function NpiIcon({ size = 20, color = '#6D786E', style = {} }) {
    return (
        <svg
            width={size}
            height={size * 1.3333333333333333}
            viewBox="0 0 20 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={style}
        >
            <path
                d="M17.6834 1H2.31655C1.58944 1 1 1.64749 1 2.44621V12.5538C1 13.3525 1.58944 14 2.31655 14H17.6834C18.4106 14 19 13.3525 19 12.5538V2.44621C19 1.64749 18.4106 1 17.6834 1Z"
                stroke={color}
                stroke-width="1.3"
                stroke-miterlimit="10"
            />
            <path
                d="M1 4.79175H19"
                stroke={color}
                stroke-width="1.3"
                stroke-miterlimit="10"
            />
            <path
                d="M9.5 8H16.5"
                stroke={color}
                stroke-width="1.3"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M9.5 10.625H14.5"
                stroke={color}
                stroke-width="1.3"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <rect
                x="3.5"
                y="7.5"
                width="4"
                height="4"
                stroke={color}
                stroke-linejoin="round"
            />
        </svg>
    )
}
